import React, { useRef } from "react";
import SlidePreview from "../common/SlideShowImage/slidePreview";
import image from "../../images";

const CardPreview = ({ title, description, images }) => {
  const sliderRef = useRef(null);

  const nextSlide = () => {
    sliderRef.current && sliderRef.current.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current && sliderRef.current.slickPrev();
  };

  return (
    <article className="p-4 bg-white rounded-xl border border-gray-100 max-w-sm w-full min-h-[400px] flex flex-col justify-between">
      <h2 className="text-lg font-semibold text-blue-600">{title}</h2>

      <div className="mt-3 flex-grow relative">
        <SlidePreview ref={sliderRef} images={images} />

        {images.length > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 opacity-50 hover:opacity-100 transition"
            >
              <img src={image.PreviousIcon} alt="Previous Icon" className="w-4 h-4" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 opacity-50 hover:opacity-100 transition"
            >
              <img src={image.NextIco} alt="Next Icon" className="w-4 h-4" />
            </button>
          </>
        )}
      </div>

      <p className="text-gray-600 text-sm mt-3">{description}</p>
    </article>
  );
};

export default CardPreview;
